import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-heading-sm mb-3" }
const _hoisted_2 = { class: "mb-3" }

import { useVModel } from "@vueuse/core";
import MatchdButton from "../MatchdButton.vue";
import MatchingModal from "../MatchingModal.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DeletionInfoModal',
  props: {
    showModal: { type: Boolean, default: false }
  },
  emits: ["update:showModal"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const showModalProxy = useVModel(props, "showModal", emit, { passive: true });

return (_ctx: any,_cache: any) => {
  return (__props.showModal)
    ? (_openBlock(), _createBlock(MatchingModal, { key: 0 }, {
        footer: _withCtx(() => [
          _createVNode(MatchdButton, {
            class: "block w-full md:w-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModalProxy.value = false))
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Ok ", -1)
            ]))]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_1, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          _createElementVNode("p", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}
}

})